// FV Upsell Script V2
console.log('FV Upsell V2 Loading...');

// Helper: Injects the upsell section into the cart drawer
function fvEnsureUpsellInjection(upsellHTML) {
    const cartDrawerContent = document.querySelector('.cart-drawer__content') || document.querySelector('cart-drawer-component');

    if (!cartDrawerContent) return;

    // Helper to perform the actual DOM insertion
    const insert = () => {
        let upsellContainer = cartDrawerContent.querySelector('.fv-cart-upsell-container');
        if (!upsellContainer) {
            upsellContainer = document.createElement('div');
            upsellContainer.className = 'fv-cart-upsell-container';
            cartDrawerContent.appendChild(upsellContainer);
        }

        if (upsellContainer.innerHTML !== upsellHTML) {
            upsellContainer.innerHTML = upsellHTML;
        }
    };

    insert();

    // Observer for persistence
    const observerTarget = document.querySelector('cart-drawer-component') || document.querySelector('#cart-drawer');
    if (observerTarget) {
        if (window.fvUpsellObserver) window.fvUpsellObserver.disconnect();

        window.fvUpsellObserver = new MutationObserver((mutations) => {
            if (!cartDrawerContent.querySelector('.fv-cart-upsell-container')) {
                insert();
            }
        });

        window.fvUpsellObserver.observe(observerTarget, { childList: true, subtree: true });

        setTimeout(() => {
            if (window.fvUpsellObserver) {
                window.fvUpsellObserver.disconnect();
                window.fvUpsellObserver = null;
            }
        }, 5000);
    }
}

// Logic: Universal Handler for Smoke Test (Form, Button, or Link)
window.fvAddUpsell = function (element) {
    if (!element) return;

    // 1. Resolve to the actual button/trigger and container form (if valid)
    let trigger = element;
    let wrapper = null;
    let variantId = null;

    if (element.tagName === 'FORM') {
        wrapper = element;
        trigger = element.querySelector('button, input[type="submit"]');
        variantId = new FormData(element).get('id');
    } else {
        trigger = element;
        wrapper = element.closest('form');
        // If it checks for dataset first, then hidden input
        variantId = trigger.dataset.variantId;
        if (!variantId && wrapper) {
            variantId = new FormData(wrapper).get('id');
        }
    }

    if (!variantId) {
        console.error('[FV Upsell] Could not find variant ID', element);
        alert('Error: No Variant ID found.');
        return;
    }

    const originalText = trigger.innerText;
    trigger.innerText = '...';
    trigger.disabled = true;

    // 2. Build Payload
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    // Identify Sections to update
    const cartDrawer = document.querySelector('cart-drawer-component');
    const sectionsToUpdate = [];

    // Try to find the cart drawer section ID dynamically
    const cartComponent = document.querySelector('cart-items-component');
    if (cartComponent && cartComponent.dataset.sectionId) {
        sectionsToUpdate.push(cartComponent.dataset.sectionId);
    }

    // Fallbacks
    if (sectionsToUpdate.length === 0) {
        if (document.getElementById('cart-drawer')) sectionsToUpdate.push('cart-drawer');
        if (document.getElementById('main-cart-items')) sectionsToUpdate.push('main-cart-items');
    }

    // FV FIX: Always request the upsell section
    sectionsToUpdate.push('fv-cart-upsell-section');

    if (sectionsToUpdate.length > 0) {
        formData.append('sections', sectionsToUpdate.join(','));
    }
    formData.append('sections_url', window.location.pathname);

    // 3. Execute Fetch
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
        }
    })
        .then(res => {
            if (!res.ok) throw new Error(res.statusText);
            return res.json();
        })
        .then(data => {
            console.log('[FV Upsell] Added successfully:', data);

            // Dispatch theme events (mimicking Product Form Component from Live Theme)
            // This structure is critical for the theme to recognize the update.
            const event = new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                    resource: data, // The cart object/response
                    sourceId: 'fv-cart-upsell',
                    data: {
                        source: 'product-form-component', // Pretend to be product form
                        variantId: variantId,
                        itemCount: 1,
                        sections: data.sections
                    }
                }
            });
            document.dispatchEvent(event);

            // Also dispatch generic cart-update for other listeners
            document.dispatchEvent(new CustomEvent('cart-update', {
                bubbles: true,
                detail: { cart: data }
            }));

            // Re-inject Upsell logic
            if (data.sections && data.sections['fv-cart-upsell-section']) {
                fvEnsureUpsellInjection(data.sections['fv-cart-upsell-section']);
            }

            // Ensure Drawer is Open (Fallback)
            const drawer = document.querySelector('cart-drawer-component');
            if (drawer) {
                if (drawer.showDialog) drawer.showDialog();
                else if (drawer.open) drawer.open();
            }

            // Reset Button
            trigger.innerText = 'Added!';
            setTimeout(() => {
                trigger.innerText = originalText;
                trigger.disabled = false;
            }, 1500);
        })
        .catch(err => {
            console.error('[FV Upsell] Add Error:', err);
            trigger.innerText = 'Error';
            trigger.disabled = false;
        });
};

// Global Listeners for Smoke Test
document.addEventListener('click', function (e) {
    // Check for our special buttons
    const btn = e.target.closest('.fv-test-btn');
    if (btn) {
        e.preventDefault();
        e.stopPropagation();
        window.fvAddUpsell(btn);
        return false;
    }
}, true);

document.addEventListener('submit', function (e) {
    if (e.target && e.target.classList.contains('fv-upsell-form')) {
        e.preventDefault();
        e.stopPropagation();
        window.fvAddUpsell(e.target);
        return false;
    }
}, true);

console.log('[FV Upsell] Live Logic Ported + Global Delegation.');
